var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconTimeChat = function SvgIconTimeChat(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F5F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 24C11.5819 24 8.00024 20.4183 8.00024 16C8.00024 11.5818 11.5819 8.00012 16.0002 8.00012C20.4184 8.00012 24.0001 11.5818 24.0001 16C24.0001 20.4183 20.4184 24 16.0002 24ZM16.0001 22.5453C19.615 22.5453 22.5455 19.6149 22.5455 16C22.5455 12.385 19.615 9.45456 16.0001 9.45456C12.3852 9.45456 9.45469 12.385 9.45469 16C9.45469 19.6149 12.3852 22.5453 16.0001 22.5453ZM16.7275 11.6365V15.6989L18.6963 17.6677C18.9803 17.9517 18.9803 18.4122 18.6963 18.6962C18.4123 18.9802 17.9518 18.9802 17.6678 18.6962L15.486 16.5144C15.3496 16.378 15.273 16.193 15.273 16.0001V11.6365C15.273 11.2349 15.5986 10.9093 16.0003 10.9093C16.4019 10.9093 16.7275 11.2349 16.7275 11.6365Z",
    fill: "#4D7080"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTimeChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-time-chat.e74ec017.svg";
export { ForwardRef as ReactComponent };